if (!window.Eurus.loadedScript.has('cart-warning-noti.js')) {
  window.Eurus.loadedScript.add('cart-warning-noti.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartWarningNoti', {
        visible: false,
        message: '',
        timer: null,
        show(message) {
          this.message = message;
          this.visible = true;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.visible = false;
          }, 7000);
        }
      })
    });
  });
}
